import { render, staticRenderFns } from "./JourneyMedia.vue?vue&type=template&id=4054d039&scoped=true&"
import script from "./JourneyMedia.vue?vue&type=script&lang=js&"
export * from "./JourneyMedia.vue?vue&type=script&lang=js&"
import style0 from "./JourneyMedia.vue?vue&type=style&index=0&id=4054d039&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054d039",
  null
  
)

export default component.exports